<template>
    <div class="tree-menu" :id="`mid-` + treeMenuData.id">

        <div @click="setMoveTarget(treeMenuData)" class="tree-menu-item-wrap">
            <div :style="indent" class="tree-menu-item" :class="{
        'current-node-item': currentNode.id === treeMenuData.id,
        'current-parent-node-item': currentMoveTargetNode.id === treeMenuData.id
    }">
                <div v-html="treeMenuData.topic" class="tree-menu-item-topic"></div>
            </div>

            <span class="current-node-item-hint" v-if="currentNode.id === treeMenuData.id" id="show-hint">{{
        $t('mindmap.treeMenu.currentMoveNode') }}</span>
            <!-- <span class="parent-node-item-hint" v-show="currentMoveTargetNode.id===treeMenuData.id">{{$t('webirs.mindmap.treeMenu.selectedParentNode')}}</span> -->
        </div>

        <mind-map-tree-menu v-for="child in treeMenuData.children" :treeMenuData="child" :currentNode='currentNode'
            :depth="depth + 1" :currentMoveTargetNode="currentMoveTargetNode" :key="child.id"
            v-show="treeMenuData.children && currentNode.id !== treeMenuData.id">
        </mind-map-tree-menu>
    </div>
</template>
<script>
import { getCurrentInstance, inject } from 'vue';
export default {
    name: 'MindMapTreeMenu',
    props: ['treeMenuData', 'depth', 'currentNode'],
    computed: {
        indent() {
            return {
                paddingLeft: `${(this.depth) * 30}px`
            }
        }
    },
    setup() {
        const that = getCurrentInstance().proxy;
        const currentMoveTargetNode = inject('currentMoveTargetNode');

        const setMoveTarget = (item) => {
            if (that.currentNode.id === item.id) return
            currentMoveTargetNode.value = item
        }
        return { currentMoveTargetNode, setMoveTarget }
    },
}
</script>
<style lang="less">
@import '../assets/color.less';

.tree-menu {
    /* 確保子元素 SVG 能相對定位 */

    .current-parent-node-item {
        // background-color: @light-color !important;
        color: white;
        background-color: @active-color !important;

        .tree-menu-item-topic {
            background-color: @light-color !important;
            border: 2px solid gray;
            border-radius: 4px;
            padding: 2px 10px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .tree-menu-item-wrap {
        position: relative;
    }

    .parent-node-item-hint {
        color: white !important;
        position: absolute;
        right: 10px;
        top: 3px;
    }

    .current-node-item-hint {
        color: @light-color !important;
        position: absolute;
        top: 3px;
        left: 50%;
    }

    .current-node-item {
        position: relative;
        cursor: not-allowed !important;

        .tree-menu-item-topic {
            background-color: @score-bgc !important;
            color: @light-color !important;
        }
    }

    .tree-menu-item {
        font-size: 16px;
        text-align: left;
        cursor: pointer;
        line-height: 1;
        // border-bottom: 1px solid #cccccc63;

        .tree-menu-item-topic {
            display: inline-block;
            background-color: #fff;
            border: 2px solid gray;
            border-radius: 4px;
            padding: 2px 10px;
            margin: 6px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-left: 30px;
            z-index: 999;
            position: relative;
        }

        img {
            width: 30px;
        }
    }
}
</style>